import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export function allOrNone(fieldNames: string[], instanceName?: string): ValidatorFn {
	if (!fieldNames) throw new Error('Fields not supplied for validation');

	return (group: UntypedFormGroup): any => {
		const fields = fieldNames.map(name => group.get(name));

		if (
			!(
				fields.every(field => !field.value && field.value !== 0) ||
				fields.every(field => field.value || field.value === 0)
			)
		)
			return instanceName ? { [instanceName]: true } : { allOrNone: true };

		return null;
	};
}
